<template>
  <v-menu offset-y open-on-hover>
    <template v-slot:activator="{ on, attrs }">
      <div color="primary" dark v-bind="attrs" v-on="on" style="cursor: pointer">
        <flag :iso="$t('langcodeShort')" />
        {{ $t("langcodeShort") }}
      </div>
    </template>
    <v-list style="min-width: 7rem">
      <v-list-item v-for="(language, index) in languages" :key="index" style="cursor: pointer" @click="changeLanguage(language)">
        <v-list-item-title>
          <flag :iso="language.flagCode" />
          {{ language.title }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
export default {
  name: "languagePicker",
  data() {
    return {
      languages: [
        {
          title: this.$t("languagesCodes.german"),
          value: "de",
          flagCode: "DE"
        },
        {
          title: this.$t("languagesCodes.english"),
          value: "en",
          flagCode: "GB"
        },
        {
          title: this.$t("languagesCodes.french"),
          value: "fr",
          flagCode: "FR"
        }
      ]
    };
  },
  computed: {
    languageCode: function () {
      return this.$store.getters["language/language"];
    }
  },
  methods: {
    async changeLanguage(lang) {
      this.$i18n.locale = lang.value;
      this.$vuetify.lang.current = lang.value;
      await this.$store.dispatch("language/setLanguage", lang.value);
      location.reload();
    }
  }
};
</script>
